import View from "../framework/view";
import template from "../../pugc/fix-handwriting";
import {HandwrittenWord} from "../bo/handwritten_word";
import {createRenderer} from "../handwriting/render";
import Server from "../server";
import jQuery from "jquery";

const classname = "fix-handwriting-view";

const styles = [ 1, 3, 7, 9 ];
//const styles = [ 1 ];

const server = Server.instance();

export class FixHandwritingView extends View {

    private word: string = "";

    constructor() {
        super(classname);
    }

    render0() {

        const data = {
            styles: styles,
            word: this.word
        };

        return this.pug(template, data);

    }

    async input() {
        this.word = this.elt().find("input[name='word'").val() as string;

        const styleContainers = this.elt().find(".style-container");

        for (let i = 0; i < styleContainers.length; i++) {
            const container = styleContainers[i];
            container.innerHTML = "";
            const style = +jQuery(container).data("style");

            for (let n = 0; n < 6; n++) {
                const h : HandwrittenWord = {
                    word: this.word,
                    salt: n
                };
                const data = await server.handwritingWords(style, [ h ]);

                const g = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                jQuery(g).data("word", h);
                jQuery(g).data("style", style);
                container.appendChild(g);

                const renderer = createRenderer(g);

                const d = (data as any)[0].rendered;

                renderer(d, 1);
            }
        }
    }

    deleteWord(svg: HTMLElement) {
        jQuery(svg).toggleClass("to-delete");
    }

    deleteWords(style: number) {
        const svgs = this.elt().find(`.style-container[data-style=${style}] svg.to-delete`);
        const words: HandwrittenWord[] = [];
        svgs.each((idx: any, elt: HTMLElement) => {
             const h = jQuery(elt).data("word") as HandwrittenWord;
             words.push(h);
        });
        console.log("delete", words);
        server.deleteHandwriting(style, words);
        svgs.remove();
    }

}

View.on(
    "." + classname,
    "change",
    "input[name='word']",
    function(that: FixHandwritingView, event, elt) {
        event.preventDefault();
        that.input();
    });

View.on(
    "." + classname,
    "click",
    "svg",
    function(that: FixHandwritingView, event, elt) {
        event.preventDefault();
        that.deleteWord(elt);
    });

View.on(
    "." + classname,
    "click",
    "button.clean",
    function(that: FixHandwritingView, event, elt) {
        event.preventDefault();
        const style = +jQuery(elt).data("style");
        that.deleteWords(style);
    });

